<template>
  <!-- 档案申请 -->
  <el-dialog title="档案调阅单" :close-on-click-modal="false" :visible.sync="isShow" center @close="cancelDialog" width="700px" top="8vh">
    <el-scrollbar :class="{formBox:form.SourceName === '履约' ? !!form.CompanyName && !!form.ProjectTitle &&  FileList.length > 0 : form.SourceName === '投标80万以上' || form.SourceName === '投标80万以下' ? !!form.CompanyName && FileList.length > 0 : false}" style="height:auto">
      <el-form ref="ruleForm" :model="form" label-width="160px" class="dialogBox">
        <el-form-item label="公司名称：" prop="CompanyName" :rules="[{ required: true, message: '请输入公司名称', trigger: ['change','blur'] }]">
          <el-input size="medium" style="width:437px" placeholder="请输入公司名称" clearable v-model.trim="form.CompanyName" @blur="checkAllInit" @keyup.native.enter='checkAllInit'></el-input>
        </el-form-item>
        <el-form-item label="文件类型：" prop="SourceName" :rules="[{ required: true, message: '请选择文件类型', trigger: 'change' }]">
          <el-select filterable placeholder="请选择文件类型" size="medium" style="width:437px" clearable v-model="form.SourceName" @change="checkAllInit">
            <el-option label="投标80万以上" value="投标80万以上" />
            <el-option label="投标80万以下" value="投标80万以下" />
            <el-option label="履约" value="履约" />
          </el-select>
        </el-form-item>
        <template v-if="form.SourceName === '履约'">
          <el-form-item label="项目名称：" prop="ProjectTitle" :rules="[{ required: true, message: '请输入项目名称', trigger: ['change','blur'] }]">
            <el-input size="medium" style="width:437px" placeholder="请输入项目名称" clearable v-model.trim="form.ProjectTitle" @blur="checkAllInit" @keyup.native.enter='checkAllInit'></el-input>
          </el-form-item>
        </template>
        <template v-if="form.SourceName === '履约' ? !!form.CompanyName && !!form.ProjectTitle : form.SourceName === '投标80万以上' || form.SourceName === '投标80万以下' ? !!form.CompanyName : false">
          <el-form-item label="文件选择：" prop="FileList" :rules="[{ required: true, message: '请选择文件', trigger: ['change','blur'] }]">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" :disabled='!checkedGameId.length'>全选</el-checkbox>
            <el-checkbox-group v-model="form.FileList" @change="handleCheckedCitiesChange" style="width:437px">
              <el-checkbox v-for="(item,i) in FileList" :label="item.SubCategoryName" :key='i' :disabled='item.disabled'></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </template>
        <!-- 运营帮借业务专员、市场专员申请时显示-->
        <template v-if="/Admin|Busier/gi.test(role)">
          <el-form-item label="运营帮借：" prop="OperationPersonName">
            <RemoteSearch size="medium" style="width:437px" :RemoteSearchList='RemoteSearchList' labelAttr='Name' valueAttr='ID' placeholder='请搜索人员名称' :modelvalue='form.OperationPersonName' @searchVal='OperatingHelpSearch' v-if="!!RemoteSearchList && RemoteSearchList.length > 0" />
          </el-form-item>
        </template>
        <!-- 业务员运营专员申请时显示 -->
        <template v-if="/Admin|Operationer/gi.test(role)">
          <el-form-item label="业务员：" prop="BusinessPersonName">
            <RemoteSearch size="medium" style="width:437px" :RemoteSearchList='RemoteSearchList' labelAttr='Name' valueAttr='ID' placeholder='请搜索人员名称' :modelvalue='form.BusinessPersonName' @searchVal='SalesmanSearch' v-if="!!RemoteSearchList && RemoteSearchList.length > 0" />
          </el-form-item>
        </template>
        <el-form-item label="借出事由：" prop="BorrowMemo" :rules="[{ required: true, message: '请输入借出事由', trigger: ['change','blur'] }]">
          <el-input size="medium" style="width:437px" placeholder="请输入借出事由" clearable v-model.trim="form.BorrowMemo"></el-input>
        </el-form-item>
        <el-form-item label="借阅类别：" prop="BorrowCategory" :rules="[{ required: true, message: '请选择借阅类别', trigger: 'change' }]">
          <el-select filterable placeholder="请选择文件类型" size="medium" style="width:437px" clearable v-model="form.BorrowCategory">
            <el-option label="现场借阅" value="现场借阅" />
            <el-option label="复印" value="复印" />
            <el-option label="带出借阅" value="带出借阅" />
            <el-option label="其它" value="其它" />
          </el-select>
        </el-form-item>
        <!-- 借阅类型为其它时显示 -->
        <template v-if="form.BorrowCategory === '其它'">
          <el-form-item label="备注：" prop="BorrowRemark" :rules="[{ required: true, message: '请输入备注', trigger: ['change','blur'] }]">
            <el-input type="textarea" size="medium" style="width:437px" placeholder="请输入备注" clearable v-model.trim="form.BorrowRemark"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="借出日期：" prop="BorrowDate" :rules="[{ required: true, message: '请选择借出日期', trigger: 'change' }]">
          <el-date-picker size="medium" v-model="form.BorrowDate" value-format="yyyy-MM-dd" type="date" :picker-options="pickerOptions" placeholder="请选择借出日期" style="width:437px" />
        </el-form-item>
        <!-- 借阅类型为带出借阅时显示 -->
        <template v-if="form.BorrowCategory === '带出借阅'">
          <el-form-item label="归还日期：" prop="ReturnDate" :rules="[{ required: true, message: '请选择归还日期', trigger: 'change' }]">
            <el-date-picker size="medium" v-model="form.ReturnDate" value-format="yyyy-MM-dd" type="date" :picker-options="pickerOptions" placeholder="请选择归还日期" style="width:437px" />
          </el-form-item>
        </template>
      </el-form>
      <div class="submitBtn">
        <el-button size="medium" class="cancelWireless" @click="cancelDialog">取消</el-button>
        <el-button size="medium" type="primary" @click="confirmEvent" :loading='submitLoad'>提交</el-button>
      </div>
    </el-scrollbar>
  </el-dialog>
</template>
<script>  
import { getBgUserList, ArchivedBorrowing, ArchivedFile, OperationArchivedFile } from "../../http/api";
export default {
  name: "ArchivesApplyFor",
  components: {},
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.getSearchList();
  },
  data() {
    return {
      role: JSON.parse(localStorage.userInfo).Role,
      submitLoad: false,
      isIndeterminate: false,
      timer: null,
      checkAll: false,     // 是否全选
      checkedGameId: [],      // 未禁用的
      RemoteSearchList: [],   // 人员列表 
      FileList: [],  // 文件列表 
      form: {
        CompanyName: "",
        SourceName: "",
        FileList: [],
        OperationPersonName: "",
        BusinessPersonName: "",
        ProjectTitle: "",
        BorrowMemo: "",
        BorrowCategory: "",
        BorrowRemark: "",
        BorrowDate: "",
        ReturnDate: ""
      },
      listQuery: {
        pageNum: 1,
        pageSize: 1000,
        where: `1=1`,
        order: "ID desc",
        select: ""
      },
      pickerOptions: {    // 禁用今天之前的时间
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
    };
  },
  methods: {
    getFileList() {     // 获取全部文件
      let { CompanyName, SourceName, ProjectTitle } = this.form;
      ArchivedFile({ where: `1=1 and SourceName='${SourceName}'` }).then(respones => {
        OperationArchivedFile({
          companyName: CompanyName,
          sourceName: SourceName,
          projectTitle: ProjectTitle
        }, 'QueryBy').then(reslut => {
          let arr = [...reslut, ...respones];
          let obj = {};
          let checkedArr = [];
          arr.forEach(item => {
            if (obj[item.SubCategoryName]) {
              obj[item.SubCategoryName].disabled = false
            } else {
              obj[item.SubCategoryName] = item
              obj[item.SubCategoryName].disabled = true
            }
          });
          let res = Object.values(obj);
          for (let i = 0; i < res.length; i++) {
            const ele = res[i];
            if (!ele.disabled) checkedArr.push(ele.SubCategoryName);
          }
          this.FileList = res;
          this.checkedGameId = checkedArr;
        }).catch(err => {
          this.FileList = [];
          this.checkedGameId = [];
        })
      })
    },
    SalesmanSearch(val) {
      this.form.BusinessPersonName = val.label;
    },
    OperatingHelpSearch(val) {
      this.form.OperationPersonName = val.label;
    },
    getSearchList() {
      getBgUserList(this.listQuery).then(res => {
        this.RemoteSearchList = res.Data;
      })
    },
    // 全选初始化
    checkAllInit() {
      this.form.FileList = [];
      this.checkAll = false;
      this.isIndeterminate = false;
      if (this.form.SourceName === '履约' && !!this.form.CompanyName && !!this.form.ProjectTitle) {
        this.getFileList();
      } else if (this.form.SourceName === '投标80万以上' || this.form.SourceName === '投标80万以下') {
        if (!!this.form.CompanyName) {
          this.form['ProjectTitle'] = '';
          this.getFileList();
        }
      }
    },
    // 全选事件
    handleCheckAllChange(val) {
      this.form.FileList = val ? this.checkedGameId : [];
      this.isIndeterminate = false;
    },
    // 选中事件
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.checkedGameId.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkedGameId.length;
    },
    confirmEvent() {
      // 判断是调用编辑还是添加接口
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitLoad = true;
          let workflow = JSON.parse(JSON.stringify(this.form));
          let fileList = [];
          this.FileList.forEach(item => {
            if (workflow.FileList.indexOf(item.SubCategoryName) >= 0) {
              fileList.push(item.ID);
            }
          });
          workflow.FileNameList = workflow.FileList.join(',');
          workflow.FileList = fileList.join(',');
          ArchivedBorrowing({ isResubmit: false, workflow }, 'Submit').then(res => {
            if (res.Code === 1) {
              this.$message.success(res.Message);
              this.$emit('cancel');
            } else {
              this.$message.error(res.Message)
            }
          }).finally(() => {
            this.submitLoad = false;
          })
        }
      });
    },
    cancelDialog() {
      this.$emit('cancel');
    },
  }
};

</script>
<style scoped>
.formBox {
  height: 68vh !important;
}
.dialogBox {
  padding-top: 16px;
}
.submitBtn {
  margin-top: 4px;
  padding-bottom: 32px;
  display: flex;
  justify-content: center;
}
.submitBtn /deep/ .el-button {
  width: 120px;
}
.submitBtn /deep/ .el-button + .el-button {
  margin-left: 32px;
}
</style>
